const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let scriptPromise = null;

const loadRecaptchaScript = () => {
  if (!SITE_KEY) return Promise.resolve(null);
  if (typeof window === "undefined") return Promise.resolve(null);
  if (window.grecaptcha && window.grecaptcha.execute) {
    return Promise.resolve(window.grecaptcha);
  }
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      `script[src^="https://www.google.com/recaptcha/api.js"]`
    );
    if (existing) {
      existing.addEventListener("load", () => resolve(window.grecaptcha));
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return scriptPromise;
};

export const getRecaptchaToken = async (action = "register") => {
  if (!SITE_KEY) return null;
  try {
    const grecaptcha = await loadRecaptchaScript();
    if (!grecaptcha) return null;
    return await new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(SITE_KEY, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  } catch (err) {
    console.error("[recaptcha] failed to get token", err);
    return null;
  }
};
